"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8126],{

/***/ 23855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ parseISO; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The previous `parse` implementation was renamed to `parseISO`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   parseISO('2016-01-01')
 *   ```
 *
 * - `parseISO` now validates separate date and time values in ISO-8601 strings
 *   and returns `Invalid Date` if the date is invalid.
 *
 *   ```javascript
 *   parseISO('2018-13-32')
 *   //=> Invalid Date
 *   ```
 *
 * - `parseISO` now doesn't fall back to `new Date` constructor
 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, dirtyOptions) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (isNaN(date) || !date) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time) || time === null) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }

  return new Date(timestamp + time + offset);
}

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: null
  };
  var year = captures[1] && parseInt(captures[1]);
  var century = captures[2] && parseInt(captures[2]);
  return {
    year: century == null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return null;
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return null;
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return null; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

/***/ }),

/***/ 50557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Tab; },
/* harmony export */   "m": function() { return /* binding */ Tabs; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _mui_material_Tabs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62722);
/* harmony import */ var _mui_material_Tab__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18661);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}



const Tabs = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Tabs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    .MuiTabScrollButton-root {\n      &.Mui-disabled {\n        opacity: unset;\n        color: ".concat(theme.palette.text.disabled, ";\n      }\n\n      > .MuiSvgIcon-fontSizeSmall {\n        font-size: ").concat(theme.typography.h5.fontSize, ";\n      }\n    }\n\n    .MuiTabs-indicator {\n      height: 4px;\n    }\n  ");
});
const Tab = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Tab__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    &.MuiTab-root {\n      min-width: unset;\n      padding: ".concat(theme.spacing(3), " ").concat(theme.spacing(4), ";\n      font-size: ").concat(theme.typography.h6.fontSize, ";\n      font-weight: initial;\n\n      &.Mui-selected {\n        font-weight: 700;\n      }\n\n      ").concat(theme.breakpoints.up("lg"), " {\n        padding: ").concat(theme.spacing(3), " ").concat(theme.spacing(6), ";\n      }\n    }\n  ");
});


/***/ }),

/***/ 8126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Vender_VenderAbout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/hooks/analytics/GtmAgent/GtmAgent.js
var GtmAgent = __webpack_require__(27582);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 2 modules
var Button = __webpack_require__(75084);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 27 modules
var format = __webpack_require__(39705);
// EXTERNAL MODULE: ./components/common/Tabs/index.js
var Tabs = __webpack_require__(50557);
;// CONCATENATED MODULE: ./components/pages/Vender/VenderAbout/Achievements.js







// 由後端完成排序，前端僅依 API 回傳順序進行年份分組。
const groupAchievementsByYear = function() {
    let achievements = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const groups = achievements.reduce((result, item)=>{
        const year = (0,parseISO/* default */.Z)(item.date).getFullYear();
        if (!result.has(year)) result.set(year, {
            year,
            items: []
        });
        result.get(year).items.push(item);
        return result;
    }, new Map());
    return Array.from(groups.values());
};
const Achievements = (param)=>{
    let { achievements , onImageOpen  } = param;
    var _groups_, _groups_1;
    const groups = groupAchievementsByYear(achievements);
    const [selectedYear, setSelectedYear] = (0,react.useState)(((_groups_ = groups[0]) === null || _groups_ === void 0 ? void 0 : _groups_.year) || false);
    const activeYear = groups.some((param)=>{
        let { year  } = param;
        return year === selectedYear;
    }) ? selectedYear : ((_groups_1 = groups[0]) === null || _groups_1 === void 0 ? void 0 : _groups_1.year) || false;
    if (!groups.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        component: "section",
        mb: 18,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "h2",
                variant: "h5",
                mb: 2,
                children: "成就經歷"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs */.m, {
                value: activeYear,
                onChange: (_, value)=>setSelectedYear(value),
                variant: "scrollable",
                scrollButtons: "auto",
                "aria-label": "成就經歷年份",
                TabIndicatorProps: {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "MuiTabs-indicatorSpan"
                    })
                },
                sx: (theme)=>({
                        mb: 6,
                        minHeight: "unset",
                        "& .MuiTabs-flexContainer": {
                            gap: "28px"
                        },
                        "& .MuiTabs-indicator": {
                            display: "flex",
                            justifyContent: "center",
                            backgroundColor: "transparent"
                        },
                        "& .MuiTabs-indicatorSpan": {
                            width: "32px",
                            borderRadius: "4px",
                            backgroundColor: theme.palette.primary.main
                        },
                        "&& .MuiTab-root": {
                            ...theme.typography.titleSmall,
                            minHeight: "unset",
                            padding: "14px 0",
                            lineHeight: 1,
                            letterSpacing: 0,
                            color: theme.palette.text.secondary,
                            "&.Mui-selected": {
                                color: theme.palette.primary.main
                            }
                        }
                    }),
                children: groups.map((param)=>/*#__PURE__*/ {
                    let { year  } = param;
                    return (0,jsx_runtime.jsx)(Tabs/* Tab */.O, {
                        id: "achievement-tab-".concat(year),
                        "aria-controls": "achievement-panel-".concat(year),
                        value: year,
                        label: String(year)
                    }, year);
                })
            }),
            groups.map((param)=>{
                let { year , items  } = param;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    id: "achievement-panel-".concat(year),
                    role: "tabpanel",
                    "aria-labelledby": "achievement-tab-".concat(year),
                    hidden: year !== activeYear,
                    px: {
                        xs: 0,
                        md: 4,
                        lg: 6,
                        xl: 8
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        display: "flex",
                        flexDirection: "column",
                        gap: 4,
                        children: items.map((item)=>{
                            var _item_image;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        component: "time",
                                        dateTime: (0,format/* default */.Z)((0,parseISO/* default */.Z)(item.date), "yyyy-MM-dd"),
                                        flex: "0 0 48px",
                                        variant: "paraBodyMedium",
                                        color: "text.minus2",
                                        children: (0,format/* default */.Z)((0,parseISO/* default */.Z)(item.date), "MM/dd")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        flex: 1,
                                        minWidth: 0,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                component: "span",
                                                variant: "paraBodyMedium",
                                                color: "text.minus2",
                                                sx: {
                                                    overflowWrap: "anywhere",
                                                    wordBreak: "break-word"
                                                },
                                                children: item.description
                                            }),
                                            (item === null || item === void 0 ? void 0 : (_item_image = item.image) === null || _item_image === void 0 ? void 0 : _item_image.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                variant: "text",
                                                size: "small",
                                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    component: "img",
                                                    src: "/img/ic_image.svg",
                                                    alt: "",
                                                    width: "16px",
                                                    height: "16px"
                                                }),
                                                onClick: ()=>{
                                                    return onImageOpen === null || onImageOpen === void 0 ? void 0 : onImageOpen({
                                                        src: item.image.url,
                                                        alt: item.description
                                                    });
                                                },
                                                sx: {
                                                    ml: 1,
                                                    px: 2,
                                                    height: "24px",
                                                    verticalAlign: "top",
                                                    color: "primary.mainPlus2",
                                                    "& .MuiButton-startIcon": {
                                                        m: 0,
                                                        mr: 1
                                                    }
                                                },
                                                children: "開啟圖片"
                                            })
                                        ]
                                    })
                                ]
                            }, item._id);
                        })
                    })
                }, year);
            })
        ]
    });
};
/* harmony default export */ var VenderAbout_Achievements = (Achievements);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ExpandLess.js
var ExpandLess = __webpack_require__(60181);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ExpandMore.js
var ExpandMore = __webpack_require__(23508);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(77366);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(21082);
;// CONCATENATED MODULE: ./components/pages/Vender/VenderAbout/CompanyIntroduction.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}











const collapsedLineCount = 10;
const imageGap = 24;
const useIsomorphicLayoutEffect =  false ? 0 : react.useLayoutEffect;
const CompanyIntroductionImageSlide = (0,emotion_styled_browser_esm/* default */.Z)(swiper_react/* SwiperSlide */.o5)(_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    && {\n      width: 80vw;\n    }\n\n    ".concat(theme.breakpoints.up("lg"), " {\n      && {\n        width: calc((100% - ").concat(imageGap * 2, "px) / 3);\n      }\n    }\n  ");
});
const CompanyIntroduction = (param)=>{
    let { introduction  } = param;
    var _introduction_images;
    const [expanded, setExpanded] = (0,react.useState)(false);
    const [isOverflow, setIsOverflow] = (0,react.useState)(false);
    const textRef = (0,react.useRef)(null);
    const content = introduction === null || introduction === void 0 ? void 0 : introduction.content;
    const images = (introduction === null || introduction === void 0 ? void 0 : (_introduction_images = introduction.images) === null || _introduction_images === void 0 ? void 0 : _introduction_images.filter((item)=>{
        var _item_image;
        return item === null || item === void 0 ? void 0 : (_item_image = item.image) === null || _item_image === void 0 ? void 0 : _item_image.url;
    }).slice(0, 3)) || [];
    useIsomorphicLayoutEffect(()=>{
        const textElement = textRef.current;
        if (!(content === null || content === void 0 ? void 0 : content.trim()) || !textElement) return;
        const updateOverflow = ()=>{
            const style = window.getComputedStyle(textElement);
            const fontSize = parseFloat(style.fontSize) || 16;
            const lineHeight = parseFloat(style.lineHeight) || fontSize * 1.5;
            const collapsedHeight = lineHeight * collapsedLineCount;
            setIsOverflow(textElement.scrollHeight > collapsedHeight + 1);
        };
        updateOverflow();
        if (typeof window.ResizeObserver === "undefined") {
            window.addEventListener("resize", updateOverflow);
            return ()=>window.removeEventListener("resize", updateOverflow);
        }
        const resizeObserver = new window.ResizeObserver(updateOverflow);
        resizeObserver.observe(textElement);
        return ()=>resizeObserver.disconnect();
    }, [
        content
    ]);
    if (!(content === null || content === void 0 ? void 0 : content.trim())) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        component: "section",
        mb: {
            xs: 12,
            md: 18
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "h2",
                variant: "h5",
                mb: 6,
                children: "公司介紹"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                ref: textRef,
                component: "div",
                variant: "paraBodyMedium",
                color: "text.minus2",
                display: "-webkit-box",
                overflow: "hidden",
                whiteSpace: "pre-wrap",
                sx: {
                    WebkitLineClamp: expanded ? "unset" : collapsedLineCount,
                    WebkitBoxOrient: "vertical",
                    overflowWrap: "anywhere",
                    wordBreak: "break-word"
                },
                children: content
            }),
            (isOverflow || expanded) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "text",
                "aria-label": expanded ? "收合" : "查看完整資訊",
                onClick: ()=>setExpanded((value)=>!value),
                endIcon: expanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandLess/* default */.Z, {
                    sx: {
                        width: 24,
                        height: 24
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                    sx: {
                        width: 24,
                        height: 24
                    }
                }),
                sx: {
                    mt: 4,
                    color: "primary.mainPlus2"
                },
                children: expanded ? "收合" : "查看完整資訊"
            }),
            !!images.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: 6,
                overflow: "hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    slidesPerView: "auto",
                    spaceBetween: imageGap,
                    children: images.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyIntroductionImageSlide, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                position: "relative",
                                borderRadius: "16px",
                                overflow: "hidden",
                                sx: {
                                    aspectRatio: "3 / 2"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: item.image.url,
                                    alt: item.alt || "",
                                    fill: true,
                                    sizes: "(max-width: 991px) 80vw, (max-width: 1600px) 33vw, 480px",
                                    style: {
                                        objectFit: "cover"
                                    }
                                })
                            })
                        }, item.image._id))
                })
            })
        ]
    });
};
/* harmony default export */ var VenderAbout_CompanyIntroduction = (CompanyIntroduction);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ButtonBase/ButtonBase.js + 8 modules
var ButtonBase = __webpack_require__(9642);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ChevronLeft.js
var ChevronLeft = __webpack_require__(19572);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ChevronRight.js
var ChevronRight = __webpack_require__(26215);
;// CONCATENATED MODULE: ./components/pages/Vender/VenderAbout/ImageCardCarousel.js











const getCarouselPageIndex = (swiper, direction)=>{
    const { activeIndex , slidesGrid , width  } = swiper;
    const currentPosition = slidesGrid[activeIndex];
    if (direction === "previous") {
        const targetPosition = Math.max(currentPosition - width, 0);
        for(let index = activeIndex - 1; index >= 0; index -= 1){
            if (slidesGrid[index] <= targetPosition) return index;
        }
        return 0;
    }
    const targetPosition1 = currentPosition + width;
    const nextIndex = slidesGrid.findIndex((position, index)=>index > activeIndex && position >= targetPosition1);
    return nextIndex === -1 ? slidesGrid.length - 1 : nextIndex;
};
const ImageCardCarousel = (param)=>{
    let { title , items =[] , onImageOpen  } = param;
    const swiperRef = (0,react.useRef)(null);
    const [isAtStart, setIsAtStart] = (0,react.useState)(true);
    const [isAtEnd, setIsAtEnd] = (0,react.useState)(items.length <= 2);
    if (!items.length) return null;
    const updateNavigationState = (swiper)=>{
        setIsAtStart(swiper.isBeginning);
        setIsAtEnd(swiper.isEnd);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        component: "section",
        mb: {
            xs: 12,
            md: 18
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                mb: 6,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: "h2",
                        variant: "h5",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        display: "flex",
                        gap: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                "aria-label": "上一排".concat(title),
                                disabled: isAtStart,
                                size: "small",
                                onClick: ()=>{
                                    const swiper = swiperRef.current;
                                    if (!swiper) return;
                                    swiper.slideTo(getCarouselPageIndex(swiper, "previous"));
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronLeft/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                "aria-label": "下一排".concat(title),
                                disabled: isAtEnd,
                                size: "small",
                                onClick: ()=>{
                                    const swiper = swiperRef.current;
                                    if (!swiper) return;
                                    swiper.slideTo(getCarouselPageIndex(swiper, "next"));
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mr: {
                    xs: -4,
                    lg: -9,
                    xl: -12,
                    xxl: -16
                },
                overflow: "hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    slidesPerView: "auto",
                    spaceBetween: 16,
                    threshold: 8,
                    grabCursor: true,
                    watchOverflow: true,
                    breakpoints: {
                        768: {
                            spaceBetween: 16,
                            slidesOffsetAfter: 16
                        },
                        992: {
                            spaceBetween: 16,
                            slidesOffsetAfter: 36
                        },
                        1200: {
                            spaceBetween: 24,
                            slidesOffsetAfter: 48
                        },
                        1600: {
                            spaceBetween: 32,
                            slidesOffsetAfter: 64
                        }
                    },
                    onSwiper: (swiper)=>{
                        swiperRef.current = swiper;
                        updateNavigationState(swiper);
                    },
                    onSlideChange: updateNavigationState,
                    onReachBeginning: updateNavigationState,
                    onReachEnd: updateNavigationState,
                    onFromEdge: updateNavigationState,
                    onResize: updateNavigationState,
                    style: {
                        overflow: "visible"
                    },
                    children: items.map((item)=>{
                        var _item_image;
                        const imageUrl = item === null || item === void 0 ? void 0 : (_item_image = item.image) === null || _item_image === void 0 ? void 0 : _item_image.url;
                        const itemName = (item === null || item === void 0 ? void 0 : item.name) || "";
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            style: {
                                width: "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                width: {
                                    xs: "70vw",
                                    sm: "36vw",
                                    md: "25vw",
                                    xxl: "400px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        p: 3,
                                        borderRadius: "16px",
                                        sx: {
                                            aspectRatio: "1 / 1"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            position: "relative",
                                            width: "100%",
                                            height: "100%",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                                    "aria-label": "查看".concat(itemName || title, "圖片"),
                                                    onClick: ()=>{
                                                        return onImageOpen === null || onImageOpen === void 0 ? void 0 : onImageOpen({
                                                            src: imageUrl,
                                                            alt: itemName
                                                        });
                                                    },
                                                    sx: {
                                                        position: "relative",
                                                        display: "block",
                                                        width: "100%",
                                                        height: "100%",
                                                        borderRadius: "12px",
                                                        overflow: "hidden"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: imageUrl,
                                                        alt: itemName,
                                                        fill: true,
                                                        draggable: false,
                                                        sizes: "(max-width: 575px) 70vw, (max-width: 767px) 36vw, (max-width: 1600px) 25vw, 400px",
                                                        style: {
                                                            objectFit: "contain"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    position: "absolute",
                                                    right: {
                                                        xs: "6px",
                                                        sm: "10px",
                                                        lg: "6px"
                                                    },
                                                    bottom: {
                                                        xs: "6px",
                                                        sm: "10px",
                                                        lg: "6px"
                                                    },
                                                    zIndex: 1,
                                                    width: {
                                                        xs: "32px",
                                                        lg: "40px"
                                                    },
                                                    height: {
                                                        xs: "32px",
                                                        lg: "40px"
                                                    },
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "50%",
                                                    bgcolor: "background.default",
                                                    boxShadow: "0 3px 3px 0 rgb(0 0 0 / 25%)",
                                                    sx: {
                                                        pointerEvents: "none",
                                                        "--image-open-icon-size": {
                                                            xs: "20px",
                                                            lg: "24px"
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/img/ic_image_open.svg",
                                                        alt: "",
                                                        width: 24,
                                                        height: 24,
                                                        draggable: false,
                                                        style: {
                                                            width: "var(--image-open-icon-size)",
                                                            height: "var(--image-open-icon-size)"
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        mt: 3,
                                        align: "center",
                                        variant: "titleMedium",
                                        color: "text.minus2",
                                        lineHeight: 1,
                                        letterSpacing: 0,
                                        display: "-webkit-box",
                                        overflow: "hidden",
                                        sx: {
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: "vertical",
                                            overflowWrap: "anywhere",
                                            wordBreak: "break-word"
                                        },
                                        children: itemName
                                    })
                                ]
                            })
                        }, item._id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var VenderAbout_ImageCardCarousel = (ImageCardCarousel);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(39477);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
;// CONCATENATED MODULE: ./components/pages/Vender/VenderAbout/ImagePreviewModal.js









const imagePreviewModalComponentsProps = {
    backdrop: {
        timeout: 500
    }
};
const imageWidthRatio = 0.8;
const mobileImageHeightRatio = 0.8;
const desktopImageHeightRatio = 0.7;
const getPreviewSize = (naturalWidth, naturalHeight, isDesktop)=>{
    if ( false || !naturalWidth || !naturalHeight) {
        return null;
    }
    const widthScale = window.innerWidth * imageWidthRatio / naturalWidth;
    const imageHeightRatio = isDesktop ? desktopImageHeightRatio : mobileImageHeightRatio;
    const heightScale = window.innerHeight * imageHeightRatio / naturalHeight;
    const scale = Math.min(widthScale, heightScale);
    return {
        width: Math.round(naturalWidth * scale),
        height: Math.round(naturalHeight * scale)
    };
};
const ImagePreviewModal = (param)=>{
    let { open , image , onClose  } = param;
    const imageRef = (0,react.useRef)(null);
    const [naturalSize, setNaturalSize] = (0,react.useState)(null);
    const [previewSize, setPreviewSize] = (0,react.useState)(null);
    const theme = (0,useTheme/* default */.Z)();
    const isDesktop = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("md"));
    const updateImageSize = (loadedImage)=>{
        if (!(loadedImage === null || loadedImage === void 0 ? void 0 : loadedImage.naturalWidth) || !(loadedImage === null || loadedImage === void 0 ? void 0 : loadedImage.naturalHeight)) return;
        const loadedNaturalSize = {
            src: image.src,
            width: loadedImage.naturalWidth,
            height: loadedImage.naturalHeight
        };
        setNaturalSize(loadedNaturalSize);
        setPreviewSize(getPreviewSize(loadedNaturalSize.width, loadedNaturalSize.height, isDesktop));
    };
    (0,react.useEffect)(()=>{
        var _imageRef_current;
        if (open && ((_imageRef_current = imageRef.current) === null || _imageRef_current === void 0 ? void 0 : _imageRef_current.complete)) {
            updateImageSize(imageRef.current);
        }
    }, [
        image === null || image === void 0 ? void 0 : image.src,
        open
    ]);
    (0,react.useEffect)(()=>{
        if (!open || (naturalSize === null || naturalSize === void 0 ? void 0 : naturalSize.src) !== (image === null || image === void 0 ? void 0 : image.src)) {
            setPreviewSize(null);
            return undefined;
        }
        const updatePreviewSize = ()=>{
            setPreviewSize(getPreviewSize(naturalSize.width, naturalSize.height, isDesktop));
        };
        updatePreviewSize();
        window.addEventListener("resize", updatePreviewSize);
        return ()=>window.removeEventListener("resize", updatePreviewSize);
    }, [
        image === null || image === void 0 ? void 0 : image.src,
        isDesktop,
        naturalSize,
        open
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        open: open,
        onClose: onClose,
        componentsProps: imagePreviewModalComponentsProps,
        "aria-label": (image === null || image === void 0 ? void 0 : image.alt) || "圖片預覽",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            py: 8,
            px: 4,
            onClick: onClose,
            sx: {
                outline: "none"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                position: "relative",
                width: previewSize ? "".concat(previewSize.width, "px") : "1px",
                height: previewSize ? "".concat(previewSize.height, "px") : "1px",
                visibility: previewSize ? "visible" : "hidden",
                onClick: (event)=>event.stopPropagation(),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        "aria-label": "關閉圖片",
                        onClick: onClose,
                        sx: {
                            position: "absolute",
                            top: "8px",
                            right: "8px",
                            zIndex: 1,
                            width: {
                                xs: "32px",
                                lg: "40px"
                            },
                            height: {
                                xs: "32px",
                                lg: "40px"
                            },
                            p: {
                                xs: 1.5,
                                lg: 2
                            },
                            bgcolor: "background.default",
                            boxShadow: "0 3px 3px 0 rgb(0 0 0 / 25%)",
                            "&:hover": {
                                bgcolor: "background.default"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                            sx: {
                                color: "primary.mainPlus2",
                                fontSize: {
                                    xs: "20px",
                                    lg: "24px"
                                }
                            }
                        })
                    }),
                    !!(image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        position: "relative",
                        width: "100%",
                        height: "100%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            ref: imageRef,
                            src: image.src,
                            alt: image.alt || "",
                            fill: true,
                            sizes: "80vw",
                            style: {
                                objectFit: "contain"
                            },
                            onLoad: (param)=>{
                                let { currentTarget  } = param;
                                return updateImageSize(currentTarget);
                            }
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var VenderAbout_ImagePreviewModal = (ImagePreviewModal);

;// CONCATENATED MODULE: ./components/pages/Vender/VenderAbout/TeamMembers.js





const buildTeamMemberAlt = (param)=>{
    let { title , name , description  } = param;
    return [
        "團隊成員",
        title,
        name,
        description
    ].filter(Boolean).join("-");
};
const getMemberGridPosition = (index, rowOffset)=>({
        gridColumn: index % 2 + 1,
        gridRow: Math.floor(index / 2) * 5 + rowOffset
    });
const getDesktopMemberGridPosition = (index, rowOffset)=>(theme)=>({
            [theme.breakpoints.up("md")]: {
                gridColumn: index % 4 + 1,
                gridRow: Math.floor(index / 4) * 5 + rowOffset
            }
        });
const isLastMemberRow = (index, memberCount, columnCount)=>Math.floor(index / columnCount) === Math.floor((memberCount - 1) / columnCount);
const TeamMembers = (param)=>{
    let { members  } = param;
    const teamMembers = (members === null || members === void 0 ? void 0 : members.slice(0, 8)) || [];
    if (!teamMembers.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        component: "section",
        mb: {
            xs: 12,
            md: 18
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "h2",
                variant: "h5",
                mb: 6,
                children: "團隊成員"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                display: "grid",
                gridTemplateColumns: {
                    xs: "repeat(2, minmax(0, 1fr))",
                    md: "repeat(4, minmax(0, 1fr))"
                },
                columnGap: {
                    xs: 4,
                    sm: 6,
                    xl: 8
                },
                textAlign: "center",
                children: teamMembers.map((member, index)=>{
                    var _member_image;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                ...getMemberGridPosition(index, 1),
                                minWidth: 0,
                                p: 3,
                                sx: [
                                    {
                                        aspectRatio: "1 / 1"
                                    },
                                    getDesktopMemberGridPosition(index, 1)
                                ],
                                children: !!(member === null || member === void 0 ? void 0 : (_member_image = member.image) === null || _member_image === void 0 ? void 0 : _member_image.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    position: "relative",
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: "21px",
                                    overflow: "hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: member.image.url,
                                        alt: buildTeamMemberAlt(member),
                                        fill: true,
                                        sizes: "(max-width: 767px) 50vw, (max-width: 1600px) 25vw, 368px",
                                        style: {
                                            objectFit: "cover"
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                ...getMemberGridPosition(index, 2),
                                minWidth: 0,
                                minHeight: "1.3em",
                                variant: "labelLarge",
                                color: "text.minus1",
                                sx: [
                                    {
                                        overflowWrap: "anywhere",
                                        wordBreak: "break-word"
                                    },
                                    getDesktopMemberGridPosition(index, 2)
                                ],
                                children: member.title ? member.title.slice(0, 10) : null
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                ...getMemberGridPosition(index, 3),
                                minWidth: 0,
                                alignSelf: "start",
                                mt: 1,
                                sx: getDesktopMemberGridPosition(index, 3),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "titleMedium",
                                    color: "text.minus1",
                                    lineHeight: 1.2,
                                    letterSpacing: 0,
                                    display: "-webkit-box",
                                    overflow: "hidden",
                                    sx: {
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                        overflowWrap: "anywhere",
                                        wordBreak: "break-word"
                                    },
                                    children: member.name.slice(0, 16)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                ...getMemberGridPosition(index, 4),
                                minWidth: 0,
                                mt: member.description ? 2 : 0,
                                sx: getDesktopMemberGridPosition(index, 4),
                                children: !!member.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "paraBodySmall",
                                    color: "text.secondary",
                                    lineHeight: 1.4,
                                    letterSpacing: 0,
                                    sx: {
                                        overflowWrap: "anywhere",
                                        wordBreak: "break-word"
                                    },
                                    children: member.description.slice(0, 50)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                ...getMemberGridPosition(index, 5),
                                minWidth: 0,
                                height: {
                                    xs: isLastMemberRow(index, teamMembers.length, 2) ? 0 : "24px",
                                    sm: isLastMemberRow(index, teamMembers.length, 2) ? 0 : "32px",
                                    md: isLastMemberRow(index, teamMembers.length, 4) ? 0 : "32px"
                                },
                                sx: getDesktopMemberGridPosition(index, 5)
                            })
                        ]
                    }, member._id || index);
                })
            })
        ]
    });
};
/* harmony default export */ var VenderAbout_TeamMembers = (TeamMembers);

;// CONCATENATED MODULE: ./components/pages/Vender/VenderAbout/index.js








const VenderAbout_useIsomorphicLayoutEffect =  false ? 0 : react.useLayoutEffect;
const VenderAbout = (param)=>{
    let { data , venderName , venderId , onContentReady  } = param;
    const [previewImage, setPreviewImage] = (0,react.useState)(null);
    VenderAbout_useIsomorphicLayoutEffect(()=>{
        onContentReady === null || onContentReady === void 0 ? void 0 : onContentReady();
    }, [
        onContentReady
    ]);
    const handleImageOpen = (image)=>{
        GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
            event: "living_action",
            living_event_name: "vender_image_view",
            living_click_name: image === null || image === void 0 ? void 0 : image.alt,
            living_click_location: "廠商公司介紹頁",
            living_vender: venderName,
            living_vender_id: venderId
        });
        setPreviewImage(image);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderAbout_CompanyIntroduction, {
                introduction: data === null || data === void 0 ? void 0 : data.introduction
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderAbout_Achievements, {
                achievements: data === null || data === void 0 ? void 0 : data.achievements,
                onImageOpen: handleImageOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderAbout_TeamMembers, {
                members: data === null || data === void 0 ? void 0 : data.teamMembers
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderAbout_ImageCardCarousel, {
                title: "認證",
                items: data === null || data === void 0 ? void 0 : data.certifications,
                onImageOpen: handleImageOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderAbout_ImageCardCarousel, {
                title: "公司執照",
                items: data === null || data === void 0 ? void 0 : data.licenses,
                onImageOpen: handleImageOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderAbout_ImagePreviewModal, {
                open: Boolean(previewImage),
                image: previewImage,
                onClose: ()=>setPreviewImage(null)
            })
        ]
    });
};
/* harmony default export */ var Vender_VenderAbout = (VenderAbout);


/***/ })

}]);